const removeLastSymbol = value => value.slice(0, -1);

export default removeLastSymbol;
